import { forwardRef } from "react";
import NavigationSection from "./navigationSection";
import Collapse from "../collapse";

const NavigationSecondary = forwardRef<
  HTMLDivElement,
  { children?: React.ReactNode; collapse?: boolean }
>(({ children, collapse = false }, ref) => {
  return (
    <Collapse in={!collapse}>
      <div>
        <div className="border-t border-secondary/10" />
        <NavigationSection ref={ref} className="px-3 py-1.5 gap-3 min-h-10">
          {children}
        </NavigationSection>
      </div>
    </Collapse>
  );
});

export default NavigationSecondary;
